<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Technician Payment Items"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Create technician payment items."
      @on-submit="createTechnicianPaymentItemsImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Technician Payment Items Template.xlsx"
              :file-provider="$importsAPI.getTechnicianPaymentItemsTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'TechnicianPaymentItemsImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'technician-payment-items-imports-add-modal',
    };
  },
  methods: {
    createTechnicianPaymentItemsImport(data, handleCreate) {
      handleCreate(this.$importsAPI.technicianPaymentItemsCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
